<div class="d-flex flex-column" *ngIf="taxStrategy">
  <div class="d-flex flex-column mb-2">
    <div class="strategy-view-label">Links</div>
    <div class="strategy-view-content" *ngIf="!taxStrategy.resources.links">No links available.</div>
    <div class="strategy-view-content content-box" *ngIf="taxStrategy.resources.links">
      <app-tpiq-froala-view [data]="taxStrategy.resources.links"></app-tpiq-froala-view>
    </div>
  </div>
  <div class="d-flex mt-2 mb-2">
    <div class="d-flex flex-column resource-files">
      <div class="content-box mb-2">
        <div class="strategy-view-label">Documents</div>
        <div class="strategy-view-content" *ngIf="resourceFiles.length == 0">
          No documents/files available.
        </div>
        <div class="d-flex flex-wrap">
          <div class="resource-file-box d-flex justify-content-between mb-2"  *ngFor="let file of resourceFiles; let i=index;">
            <div *ngIf="file.fileType === 'pdf'"><img src="../../../images/tpiq-icons/pdf-icon.png"/></div>
            <div *ngIf="file.fileType === 'excel'"><img src="../../../images/tpiq-icons/excel-icon.png"/></div>
            <div class="resource-name">{{file.name}}</div>
            <div class="pointer">
              <img (click)="getFileData(file)" src="../../../images/tpiq-icons/download_icon.png"/>
            </div>
          </div>
        </div>
      </div>
      <div class="content-box mt-2">
        <div class="strategy-view-label">Images</div>
        <div class="strategy-view-content" *ngIf="images.length == 0">
          No images available.
        </div>
        <div class="d-flex image-preview mb-2" *ngIf="showPreview && currentSelectedImage && currentSelectedImage.temporaryURL">
          <img class="image-zoom" [src]="currentSelectedImage.temporaryURL"/>
        </div>
        <div class="d-flex mt-2 flex-wrap" *ngIf="images.length > 0">
          <div class="pointer resource-image mb-2" [ngClass]="(currentSelectedImage && (file.name === currentSelectedImage.name)) ? 'selected-image' : ''" (click)="showImagePreview(file)" [ngStyle]="{'background-image': file.temporaryURL ? 'url(' + file.temporaryURL + ')': '', 'background-size': 'cover'}" *ngFor="let file of images; let i=index;"></div>
        </div>
      </div>
    </div>
    <div class="resource-videos content-box">
      <div class="strategy-view-label">Videos</div>
      <div class="strategy-view-content" *ngIf="taxStrategy.resources.videos && taxStrategy.resources.videos.length == 0">
        No videos available.
      </div>
      <div class="d-flex flex-column resource-video-box mb-2" *ngFor="let video of taxStrategy.resources.videos; let index = index;">
        <ng-template [ngIf]="video.name">
          <div class="d-flex justify-content-between">
            <div class="resource-name">{{video.name}}</div>
            <div class="pointer">
              <img (click)="downloadVideo(video)" src="../../../images/tpiq-icons/download_icon.png"/>
            </div>
          </div>
          <div *ngIf="video" class="text-center mt-2">
            <video class="video-tag" style="margin: 0 auto;width: 100%; height: 300px;" oncontextmenu="return false;" controlsList="nodownload" controls="" preload="auto" poster=""><source src="{{video.link}}" type="video/mp4"></video>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>

